import styles from "./Badge.module.css"

const Badge = ({name, color, size="medium"}) => {

    const applySizeStyle = (size) => {
        switch(size){
            case 'small':
                return styles.small
            case 'medium':
                return styles.medium
            case 'large':
                return styles.large
            default:
                return styles.medium
        }
    }

    return (
        <div className={`${styles.container} ${applySizeStyle(size)}`} style={{'--badge-color' : color,}}>
            {name}
        </div>
    )

}

export default Badge